module.exports = __webpack_public_path__ + "media/fonts/MatterSQ-Light-9461f30c7aa48098aaa0079e4be43ece.ttf";